export type NonEmptyArray<T> = [T, ...T[]];

export type OneOrMore<T> = T | NonEmptyArray<T>;

/** Ensure the given `value` doesn't fall outside the range `min`-`max`. */
export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max));

/** Ensure the given `value` doesn't have greater than `decimals` significant digits. */
export const decimalClamp = (value: number, decimals: number) => parseFloat(value.toFixed(decimals));

/** Ensure the given `value` is divisible by `step`. */
export const stepClamp = (value: number, step: number) => {
    if (!step) return value;
    return Math.round(value / step) * step;
};
